import React, { memo } from 'react';
import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import Tooltip from '@atlaskit/tooltip';
import type { PriorityData } from '../../../../common/types';

type Props = {
	value: string;
	priorities: PriorityData;
};

const defaultIconUrl = `${window.location.origin}/images/icons/priorities/medium.svg`;

export const PriorityCell = ({ value, priorities }: Props) => {
	if (value === '') {
		return null;
	}

	const priorityIconUrl = priorities?.get(value)?.iconUrl ?? defaultIconUrl;

	return (
		<Wrapper>
			<Tooltip content={value} position="bottom-start">
				<ImageIcon
					src={priorityIconUrl}
					data-testid="project-create-importer-upload-flow.ui.mapping-screen.mapping-table.priority-cell.image-icon"
				/>
				<span>{value}</span>
			</Tooltip>
		</Wrapper>
	);
};

PriorityCell.displayName = 'PriorityCell';

export default memo<Props>(PriorityCell);

const iconSize = 22;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Wrapper = styled.div({
	overflow: 'hidden',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'> div': {
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'row',
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	span: {
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ImageIcon = styled.img({
	height: `${iconSize}px`,
	marginRight: token('space.100', '8px'),
	width: `${iconSize}px`,
});
